import { Link } from 'react-router-dom';
import { formatDuration } from '../../features/pilotMath/format';
import { pilotSummary } from '../../features/pilotMath/store';
import { usePilotState } from '../../features/pilotMath/usePilotState';

export function TeacherDashboard() {
  const [state] = usePilotState();
  const summary = pilotSummary(state);
  const needsReview = state.attempts.filter((attempt) => !attempt.firstAttemptCorrect).length;
  const levelUpCandidates = Object.values(state.progress).filter((skill) => skill.masteryPercent >= 85 && skill.evidenceCount > 0).length;

  return (
    <div className="stack">
      <div><h1>Dashboard Guru</h1><p className="muted">Prioritaskan murid berdasarkan evidence, bukan sekadar nilai akhir.</p></div>
      <section className="grid grid--3">
        <div className="metric"><span>Aktif hari ini</span><strong>{state.status === 'in_progress' ? 1 : 0}</strong><span className="muted">pilot</span></div>
        <div className="metric"><span>Perlu review</span><strong>{needsReview}</strong><span className="muted">first-attempt error</span></div>
        <div className="metric"><span>Level-up candidate</span><strong>{levelUpCandidates}</strong><span className="muted">skill ≥85%</span></div>
      </section>
      <section className="card">
        <h2>{state.student.displayName}</h2>
        <p>{summary.completed}/{summary.totalQuestions} soal · first-attempt {summary.firstAttemptAccuracy}% · aktif {formatDuration(summary.totalActiveMs)}</p>
        <div className="button-row"><Link className="btn btn--primary" to="/teacher/students">Buka monitor murid</Link></div>
      </section>
    </div>
  );
}
